export default class Request {
    constructor(url, params, method) {
        this.method = method || 'GET';
        this.params = params || {};
        this.url = url || '';
        this.json = true;
        this.files = [];
        this.callbacks = {
            'done': response => {},
            'error': response => {},
            'upload': response => {}
        };
    }

    get() {
        this.method = 'GET';
        return this;
    }

    post() {
        this.method = 'POST';
        return this;
    }

    setUrl(url) {
        this.url = url;
        return this;
    }

    setParams(params) {
        this.params = params;
        return this;
    }

    onDone(callback) {
        this.callbacks.done = callback;
        return this;
    }

    onUploadProgress(callback) {
        this.callbacks.upload = callback;
        return this;
    }

    onFail(callback) {
        this.callbacks.error = callback;
        return this;
    }

    isText() {
        this.json = false;
        return this;
    }

    addFiles(files) {
        this.files = files;
        return this;
    }

    execute() {
        let params = {
            method: this.method
        };

        if (this.method === 'POST') {
            let formData = new FormData();
            Object.keys(this.params).forEach(key => {
                if (Array.isArray(this.params[key])) {
                    this.params[key].forEach(item => {
                        formData.append(key, item);
                    });
                } else {
                    formData.append(key, this.params[key]);
                }
            });
            params.body = formData;
        } else if (this.params) {
            this.url += '?' + Object.keys(this.params).map(key => key + '=' + this.params[key]).join('&');
        }

        fetch(this.url, params)
            .then(response => this.json ? response.json() : response.text())
            .then(result => this.callbacks.done(result))
            .catch(response => this.callbacks.error(response));
    }

    upload() {
        let formData = new FormData();

        Array.from(this.files).forEach(file => {
            formData.append('file[]', file);
        });

        if (this.params) {
            this.url += '?' + Object.keys(this.params).map(key => key + '=' + this.params[key]).join('&');
        }

        let xhr = new XMLHttpRequest();
        xhr.open(this.method, this.url, true);

        xhr.upload.addEventListener('progress', e => {
            this.callbacks.upload(Math.floor(e.loaded / (e.total / 100)));
        });

        xhr.addEventListener('readystatechange', () => {
            if (xhr.readyState === 4) {
                if (xhr.status === 200) {
                    return this.callbacks.done(this.json ? JSON.parse(xhr.response) : xhr.responseText);
                }

                return this.callbacks.error(this.json ? JSON.parse(xhr.response) : xhr.responseText);
            }
        });

        xhr.send(formData);
    }
}